var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{class:_vm.getClassName,style:(_vm.getStyle),attrs:{"one":_vm.totalMssages}},_vm._l((_vm.messages),function(val,index){return _c('li',{key:index},[_vm._v(_vm._s(val))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }